'use client';

import { FormHelperText } from '@/components/field';
import classNames from 'classnames';
import type { FormikErrors, FormikTouched } from 'formik';
import { useTranslation } from 'react-i18next';

import classes from './SubmitWrapper.module.scss';

const hasError = (touched: FormikTouched<unknown>, errors: FormikErrors<unknown>): boolean => {
  if (!touched || !errors) return false;

  const check = (t: any, e: any): boolean => {
    return Object.keys(t).some((key) => {
      const touchedValue = t[key];
      const errorValue = e?.[key];
      if (typeof touchedValue === 'object' && touchedValue !== null && !Array.isArray(touchedValue)) {
        return check(touchedValue, errorValue);
      }
      return touchedValue && !!errorValue;
    });
  };

  return check(touched, errors);
};

const SubmitWrapper: React.FC<{
  formikErrors: FormikErrors<unknown>;
  formikTouched: FormikTouched<unknown>;
  customClassName?: string;
  children?: React.ReactNode;
}> = ({ formikErrors, formikTouched, customClassName, children }) => {
  const { t } = useTranslation();

  const showError = hasError(formikTouched, formikErrors);

  return (
    <div className={classNames(classes.submitWrapper, customClassName!, 'submitWrapper')}>
      {children}
      {showError && (
        <FormHelperText error aria-label="Fehlermeldung, ungültige Eingabe im Formular">
          <span aria-hidden="true"> {t('Angabenfehler')}</span>
        </FormHelperText>
      )}
    </div>
  );
};

export default SubmitWrapper;
